import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';

import { SliderLight } from '../../../Slider/SliderLight';
import { cards, cardColors } from '../constants';
import { OfferReward } from '../Reward';

import styles from './styles.module.scss';

export const OffersBlockMobile = () => (
  <>
    <Space direction="vertical" size={8} align="center">
      <Heading level={2}>Офферы</Heading>
      <Text size={14} className="h-text-center">
        Лучшие предложения для монетизации трафика
      </Text>
    </Space>
    <div className={styles.cards}>
      <SliderLight variableWidth>
        {cards.map(({ id, title, short, reward }, index) => (
          <div key={id} className={styles['card-wrapper']}>
            <Card color={cardColors[index % cardColors.length]} size={16} className={styles.card}>
              <Space direction="vertical" size={24} justify="space-between">
                <Space direction="vertical" size={12}>
                  <Heading level={3}>{title}</Heading>
                  <Text>{short}</Text>
                </Space>
                <OfferReward reward={reward} />
              </Space>
            </Card>
          </div>
        ))}
      </SliderLight>
    </div>
  </>
);
